import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */

/**
 * {@link RTCIceCandidate} parses an ICE candidate gathered by the browser
 * and returns a IceCandidate object
 */
export var IceCandidate = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param iceCandidate RTCIceCandidate coming from the browser
   */
  function IceCandidate(iceCandidate) {
    var isRemote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, IceCandidate);

    /**
     * Whether this is deleted from the list of candidate gathered
     */
    this.deleted = false;
    var cost;
    var parts = iceCandidate.candidate.split('network-cost ');

    if (parts[1]) {
      cost = parseInt(parts[1], 10);
    }

    this.candidateType = iceCandidate.type;
    this.ip = iceCandidate.ip || iceCandidate.address;
    this.isRemote = isRemote;
    this.networkCost = cost;
    this.port = iceCandidate.port;
    this.priority = iceCandidate.priority;
    this.protocol = iceCandidate.protocol;
    this.relatedAddress = iceCandidate.relatedAddress;
    this.relatedPort = iceCandidate.relatedPort;
    this.tcpType = iceCandidate.tcpType;
    this.transportId = iceCandidate.sdpMid;
  }
  /**
   * Get the payload object for insights
   */


  _createClass(IceCandidate, [{
    key: "toPayload",
    value: function toPayload() {
      return {
        'candidate_type': this.candidateType,
        'deleted': this.deleted,
        'ip': this.ip,
        'is_remote': this.isRemote,
        'network-cost': this.networkCost,
        'port': this.port,
        'priority': this.priority,
        'protocol': this.protocol,
        'related_address': this.relatedAddress,
        'related_port': this.relatedPort,
        'tcp_type': this.tcpType,
        'transport_id': this.transportId
      };
    }
  }]);

  return IceCandidate;
}();